
const PictViewClass = require('pict-view');

class LIMSSampleRecordEdit extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.ActiveSampleLogs = [];

		this.AppData.SampleDetails = { };

		/** @type {Record<string, any>} */
		this.manifest = require('./defaultSampleEditManifest.json');
	}

	async onInitializeAsync(fCallback)
	{
		return super.onInitializeAsync(fCallback);
	}

	async onNavigate(pSampleGUID, pResetState = true)
	{
		this.AppData.GUIDSample = pSampleGUID;
		if (pResetState)
		{
			delete this.AppData.LoggedBy;
			//TODO: if we came here from the sample view screen, do we want to leave this rather than re-loading?
			this.AppData.SampleDetails = { };
		}
		if (this.initialized)
		{
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
		}
		await new Promise((resolve) => this.renderAsync((pError) =>
		{
			if (pError)
			{
				this.log.error(`Error rendering Sample Edit view: ${pError.message || pError}`, { stack: pError.stack });
			}
			else
			{
				this.log.info('Sample Edit view rendered');
			}
			resolve();
		}));
	}

	async onBeforeRenderAsync(fCallback, pRenderable)
	{
		const session = await this.pict.providers.SessionProvider.getSession();
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Sample', 'Edit', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-SampleEdit'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-SampleEdit'].options.DefaultDestinationAddress = '#LIMSSampleRecordEdit-Container';
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-SampleEdit'].rebuildCustomTemplate();
			this.initialized = true;
		}
		super.onBeforeRenderAsync(async () =>
		{
			let tmpInitialBundleGather = Promise.resolve();
			if (Array.isArray(this.manifest.InitialBundle) && this.manifest.InitialBundle.length > 0)
			{
				tmpInitialBundleGather = new Promise((resolve) => this.pict.providers.FormInitialBundle.gatherInitialBundle(this.manifest, (pError) =>
				{
					if (pError)
					{
						this.log.error(`Error gathering the Sample Edit initial bundle: ${pError.message || pError}`, { stack: pError.stack });
					}
					resolve();
				})).catch((pError) =>
				{
					this.log.error(`Error gathering the Sample Edit initial bundle: ${pError.message || pError}`, { stack: pError.stack });
				});
			}
			try
			{
				await this.pict.PictApplication.applySampleDisabledState();
				this.pict.views['PictSectionForm-SampleEdit'].rebuildCustomTemplate();
				this.log.info('Sample-Record-Edit rendered with Active Record', this.AppData.SampleDetails);

				if (this.AppData.GUIDSample)
				{
					this.log.info('Sample Details view opened with GUIDSample', this.AppData.GUIDSample);
					// get the Sample record by ID
					const tmpRecord = await this.pict.providers.SampleProvider.getSampleByGUID(this.AppData.GUIDSample);
					if (tmpRecord)
					{
						this.AppData.SampleDetails = tmpRecord;
						this.log.info('Sample Details view opened with Sample record', this.AppData.SampleDetails);
						// get the logs for the Sample
						const tmpLogs = await this.pict.providers.SampleLogProvider.getSampleLogsByIDSample(this.AppData.SampleDetails.IDSample);
						this.ActiveSampleLogs = tmpLogs;
						// Resolve spec-year scope for downstream picker providers
						// (e.g. MaterialSelector). Awaiting ensures the scope is
						// loaded before the form renders so pickers apply the
						// filter on first search. Fails open per §5.1 of the
						// spec-year design doc.
						if (this.pict.providers.SpecScopeResolver && tmpRecord.IDProject > 0)
						{
							await this.pict.providers.SpecScopeResolver.loadForProject(tmpRecord.IDProject);
						}
					}
					else
					{
						//FIXME: should notify the user / show a message / render a template ...
						this.log.error('Sample record not found for ID', this.AppData.GUIDSample);
					}
				}
			}
			catch (error)
			{
				this.log.error('Error in Sample Details onBeforeRenderAsync:', error);
			}

			await tmpInitialBundleGather;
			return fCallback();
		}, pRenderable);
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {ErrorCallback} fCallback
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-SampleEdit'].render();
		this.pict.views['PictSectionForm-SampleEdit'].marshalToView();
		if (this.AppData.disableSampleEdit)
		{
			document.getElementById('LIMSSampleRecordPanel-Save-Changes')?.classList?.add?.('is-hidden');
		}
		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	/**
	 * Open the Sample detail view for the selected Sample to view the full details
	 * @param {number|string} pIDSample - The ID of the Sample to view
	 * @param {object} pSampleRecord - The Sample record to view
	 * @param {string} pOpenTab - The tab to open when the Sample detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showSampleDetailView(pIDSample, pSampleRecord, pOpenTab = 'Details')
	{
		// if a Sample record is passed in, use it, otherwise get the Sample record by ID
		if (pSampleRecord)
		{
			this.AppData.SampleDetails = Array.isArray(pSampleRecord) ? pSampleRecord[0] : pSampleRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.SampleProvider.getSampleByID(pIDSample);
			this.AppData.SampleDetails = tmpRecord;
		}
		// if the Sample record is not found, log an error and return
		if (!this.AppData.SampleDetails)
		{
			this.log.error('Sample record not found for ID', pIDSample);
			return;
		}
		else
		{
			// get the logs for the Sample
			const tmpLogs = await this.pict.providers.SampleLogProvider.getSampleLogsByIDSample(this.AppData.SampleDetails.IDSample);
			this.ActiveSampleLogs = tmpLogs;
		}
		// render the Sample detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('Sample Edit rendered with Active Record', this.AppData.SampleDetails);
				resolve();
			});
		});
	}

	/**
	 * This method is used to add a new log to the Sample and refresh the Sample Details view.
	 * @return {Promise<void>}
	 * @async
	 */
	async addNewLogToSample()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('No active Sample to add log to');
			return;
		}
		this.pict.ContentAssignment.addClass('#LIMSSampleRecordPanel-Logs-Add-Button', 'is-loading');
		this.log.info('Adding new log to Sample ID:', this.AppData.SampleDetails.IDSample);

		this.log.info('Attempting to fetch geolocation...');
		const geoCoords = await this.pict.providers.GeoProvider.getGeoCoords();

		if (geoCoords)
		{
			// If we got a geolocation, update the sampel with it.
			await this.pict.providers.SampleProvider.updateSample(
				{
					IDSample: this.AppData.SampleDetails.IDSample,
					CaptureLatitude: geoCoords.CaptureLatitude,
					CaptureLongitude: geoCoords.CaptureLongitude,
				},
			);
			this.AppData.SampleDetails.CaptureLatitude = geoCoords.CaptureLatitude;
			this.AppData.SampleDetails.CaptureLongitude = geoCoords.CaptureLongitude;
		}

		const tmpLogMessage = this.pict.ContentAssignment.readContent('#LIMSSampleRecordEdit-Tab-Logs-CreateNewLog-Textarea');
		const tmpOptions = {
			IDSample: this.AppData.SampleDetails.IDSample,
			CaptureLatitude: this.AppData.SampleDetails.CaptureLatitude,
			CaptureLongitude: this.AppData.SampleDetails.CaptureLongitude,
			Notes: tmpLogMessage,
		};
		// go make the new log entry, then refresh the view
		await this.pict.providers.SampleLogProvider.createSampleLog(tmpOptions);
		this.log.info('Sample Log added to Sample', this.AppData.SampleDetails.IDSample);
		// NOTE: can't go back to "Logs" since we're already on "Logs" tab
		await this.showSampleDetailView(this.AppData.SampleDetails.IDSample, null, 'Logs');
		// a bit hacky to get back to the same tab again, but limited time right now
		document.getElementById('LIMSSampleRecordPanel-Logs-Tab').click();
	}

	/**
	 * This method is used to clear the new log entry field in the Sample Details view.
	 * @return {void}
	 */
	clearNewLogEntry()
	{
		this.pict.ContentAssignment.assignContent('#LIMSSampleRecordEdit-Tab-Logs-CreateNewLog-Textarea', '');
	}

	/**
	 * This method is used to handle the Print button click for building the print view.
	 * @return {void}
	 */
	printQRCodeLabel()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('No active Sample to print QR Code for');
			return;
		}
		this.log.info('Printing Sample Details');
		this.pict.providers.QRCodeProvider.printDecoratedEntity('Sample', this.AppData.SampleDetails.QRCode);
	}

	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
		if (pTabID?.includes('Print'))
		{
			this.pict.providers.QRCodeProvider.printDecoratedEntity('Sample', this.AppData.SampleDetails.QRCode, 'LIMSSampleRecordEdit-PrintPreview');
		}
	}

	async createNewSample(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		event.currentTarget.classList.add('is-loading');
		this.log.info('Creating new sample...');
		this.log.info(JSON.stringify(this.AppData.SampleDetails));

		const tmpSample = this.AppData.SampleDetails;
		// save the Sample
		try
		{
			const tmpResult = await this.pict.providers.SampleProvider.createSample(tmpSample, null, true);
			this.AppData.SampleDetails = tmpResult;
			this.log.info('Sample created, going to the Details view...');
			this.goToReadView();
		}
		catch (error)
		{
			this.log.error('Error creating sample', error);
			this.pict.views.HeadlightPanels.toast({ message: `Error creating Sample: ${error.message || error}`, type: 'is-danger' });
		}
	}

	goToEditView()
	{
		if (!this.AppData.SampleDetails)
		{
			this.log.error('No active Sample to edit');
			return;
		}
		this.log.info('Going to Edit Sample view for Sample GUID:', this.AppData.SampleDetails.GUIDSample);
		this.pict.providers.LIMSRouter.router.navigate(`/Sample/${this.AppData.SampleDetails.GUIDSample}/Edit`);
	}

	goToReadView(pEvent)
	{
		if (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		if (!this.AppData.SampleDetails)
		{
			this.log.error('No active Sample to view');
			return;
		}
		this.log.info('Going to Read Sample view for Sample GUID:', this.AppData.SampleDetails.GUIDSample);
		this.pict.providers.LIMSRouter.router.navigate(`/Sample/${this.AppData.SampleDetails.GUIDSample}`);
	}

	async saveSampleChanges()
	{
		this.log.info('Saving Sample changes');
		const tmpSample = this.AppData.SampleDetails;
		// save the Sample
		const tmpResult = await this.pict.providers.SampleProvider.updateSample(tmpSample);
		if (tmpResult)
		{
			this.log.info('Sample changes saved successfully');
			this.goToReadView();
			this.pict.views.HeadlightPanels.toast({ message: 'Sample changes saved successfully', type: 'is-success' });
		}
		else
		{
			this.log.error('Error saving Sample changes');
			this.pict.views.HeadlightPanels.toast({ message: 'Error saving Sample changes', type: 'is-danger' });
		}
	}

	handleFormSubmitAction(event)
	{
		event.preventDefault();
		event.stopPropagation();
		this.log.info('Sample form submitted');

		//FIXME: async? error handling?
		this.saveSampleChanges();
	}
}

module.exports = LIMSSampleRecordEdit;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSSampleRecordEdit',
	DefaultRenderable: 'LIMSSampleRecordEdit',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSSampleRecordEdit-Wrapper',
			Template: /*html*/`
			<form class="container form" data-sample-id="{~D:Record.IDSample~}" onsubmit="_Pict.views.LIMSSampleRecordEdit.handleFormSubmitAction(event);">
				{~T:LIMSSampleRecordEdit-SampleHeader:AppData.SampleDetails~}
				<!-- Sample Panel Tabs -->
				{~T:LIMSSampleRecordEdit-Panel-Tabs:AppData.SampleDetails~}
				<!-- LIMSSampleRecordEdit Content > Tab Details View -->
				<div id="LIMSSampleRecordPanel-Details-Content" class="tab-content is-active">
					<div id="LIMSSampleRecordEdit-Details-Container">{~T:LIMSSampleRecordEdit-Tab-Details:AppData.SampleDetails~}</div>
				</div>
				<!-- LIMSSampleRecordEdit Content > Tab Logs View -->
				<div id="LIMSSampleRecordPanel-Logs-Content" class="tab-content">
					<div id="LIMSSampleRecordEdit-Logs-Container">{~T:LIMSSampleRecordEdit-Tab-Logs:Context[0].ActiveSampleLogs~}</div>
				</div>
				<!-- LIMSSampleRecordEdit Content > Tab Print View -->
				<div id="LIMSSampleRecordPanel-Print-Content" class="tab-content">
					<div id="LIMSSampleRecordEdit-Print-Container">{~T:LIMSSampleRecordEdit-Tab-Print:AppData.SampleDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Panel-Tabs',
			Template: /*html*/`
			<nav class="tabs is-right mt-2">
				<ul>
					<li class="is-active">
						<a id="LIMSSampleRecordPanel-Details-Tab" class="is-active" onclick="_Pict.views.LIMSSampleRecordEdit.toggleTabContent(event, 'LIMSSampleRecordPanel-Details')">
							<span class="icon">
								<i class="fa fa-fw fa-info-circle"></i>
							</span>
							<span class="icon-text">
								Details
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSSampleRecordPanel-Logs-Tab" onclick="_Pict.views.LIMSSampleRecordEdit.toggleTabContent(event, 'LIMSSampleRecordPanel-Logs')">
							<span class="icon">
								<i class="fa fa-fw fa-list-timeline"></i>
							</span>
							<span class="icon-text">
								Logs
							</span>
						</a>
					</li>
					<li>
						<a id="LIMSSampleRecordPanel-Print-Tab" onclick="_Pict.views.LIMSSampleRecordEdit.toggleTabContent(event, 'LIMSSampleRecordPanel-Print');">
							<span class="icon">
								<i class="fa fa-fw fa-qrcode"></i>
							</span>
							<span class="icon-text">
								Print
							</span>
						</a>
					</li>
				</ul>
			</nav>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-SampleHeader',
			Template: /*html*/`
			<div class="container columns has-background-text-soft is-mobile is-vcentered mb-0" style="min-height: 130px">
				<div class="column px-5">
					<p class="title is-4">{~D:Record.Name:N/A~}</p>
					<p class="subtitle is-6 has-text-text-50 mb-2">
						<span class="icon">
							<i class="fas fa-fw fa-qrcode fa-sm"></i>
						</span>
						<span class="icon-text">{~D:Record.QRCode~}</span>
					</p>
					<span class="label is-size-7 has-text-text-50 mb-0">Status:</p>
					{~StatusPill:Record.Status~}
				</div>
				<div class="column is-3" style="flex-basis: content;">
					<figure class="image is-96x96 mr-1">{~QRCodeImage:Record.QRCode^96x96^~}</figure>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSSampleRecordEdit-Container" class="px-5 mt-2"></div>
			{~T:LIMSSampleRecordEdit-Tab-Details-Buttons-Edit:AppData.SampleDetails~}`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Details-Buttons-Edit',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column px-3 py-1 has-text-right">
					<button type="button" id="LIMSSampleRecordEdit-Tab-Details-Cancel-Button" class="button is-link is-soft" onclick="_Pict.views.LIMSSampleRecordEdit.goToReadView(event)">
						<span class="icon">
							<i class="fa fa-fw fa-times"></i>
						</span>
						<span class="icon-text">Cancel</span>
					</button>
					<button type="submit" id="LIMSSampleRecordPanel-Save-Changes" class="button is-link">
						<span class="icon">
							<i class="fa fa-fw fa-save"></i>
						</span>
						<span class="icon-text">Save Changes</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Logs',
			Template: /*html*/`
				{~TIfAbs:LIMSSampleRecordEdit-Tab-Logs-Items:Record:Record.length^>^0~}
				{~TIfAbs:LIMSSampleRecordEdit-Tab-Logs-Empty:Record:Record.length^<=^0~}
				{~T:LIMSSampleRecordEdit-Tab-Logs-Entry:AppData.SampleDetails~}`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Logs-Empty',
			Template: /*html*/`
			<div class="notification empty-message m-3 is-fullwidth">
				<p class="has-text-centered">
					<span class="icon">
						<i class="fa fa-fw fa-info-circle"></i>
					</span>
					<span class="icon-text">No logs are available for this sample.</span>
				</p>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Logs-Items',
			Template: /*html*/`
			<div id="LIMSSampleRecordEdit-Tab-Logs-Items">
				{~TS:LIMSSampleRecordEdit-Tab-Logs-Item:Record~}
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Logs-Item',
			Template: /*html*/`
			<div class="panel-block is-block-flex is-align-items-left is-relative p-4">
				<figure class="image">
					<img class="preview-image" style="max-width: 100px;" onerror="this.onerror = null; this.src='./images/no-location-data-light.png'" src="{~GoogleMapURL:Record^100x100^~}" alt="Geolocation for sample" />
				</figure>
				<div class="is-block-flex is-align-items-left m-2" style="flex-grow: 1">
					<div class="is-size-7">#{~D:Record.IDSampleLog~}</div>
					<div>{~D:Record.Notes~}</div>
					<div class="is-size-7">
						<span class="has-text-soft">on</span>
						<span>{~DateFormatNoFallback:Record.CreateDate^MMMM DD, YYYY - hh:mm a^~}</span>
						<span class="has-text-soft">by</span>
						<span>{~Entity:User^Record.CreatingIDUser^LIMSSampleRecordEdit-Tab-Logs-Item-User^~}</span>
					</div>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Logs-Item-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Logs-Entry',
			Template: /*html*/`
			<div class="column" style="border-top: 1px solid var(--bulma-border);">
				<textarea id="LIMSSampleRecordEdit-Tab-Logs-CreateNewLog-Textarea" style="min-height: 4rem" class="textarea" placeholder="Enter log notes here"></textarea>
				<div class="buttons mt-2 is-right">
					<button type="button" class="button is-link is-soft" title="Clear log entry" onclick="_Pict.views.LIMSSampleRecordEdit.clearNewLogEntry()">
						<span class="icon">
							<i class="fa fa-fw fa-refresh"></i>
						</span>
						<span>Clear</span>
					</button>
					<button type="button" class="button is-link" title="Add new log to sample"onclick="_Pict.views.LIMSSampleRecordEdit.addNewLogToSample()">
						<span class="icon">
							<i class="fa fa-fw fa-plus"></i>
						</span>
						<span>Add Log</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSSampleRecordEdit-Tab-Print',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column" id="LIMSSampleRecordEdit-PrintPreview">
				</div>
			</div>
			<div class="columns px-3 m-0">
				<div class="column">
					<div class="buttons mt-2 is-right">
						<button type="button" class="button is-link" title="Print qrcode label" onclick="_Pict.views.LIMSSampleRecordEdit.printQRCodeLabel()">
							<span class="icon">
								<i class="fa fa-fw fa-print"></i>
							</span>
							<span>Print QRCode Label</span>
						</button>
					</div>
				</div>
			</div>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSSampleRecordEdit',
			TemplateHash: 'LIMSSampleRecordEdit-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};
